import React from 'react';
import { observer } from 'mobx-react';

import Header from './components/header';
import Patient from './components/patient';
import List from 'components/drill-down-layout/components/list';
import ListItem from 'components/drill-down-layout/components/list/components/list-item';

import PatientIcon from 'assets/icons/patient.svg';

import './patient-icon.scss';


const PatientsList = ({
  patientsStore,
  patientsIncompleteInfoRouteStore,
  setFilterValue,
  listPatients,
  rootRoute,
}) => (
  <List
    header={<Header
      filterValue={patientsIncompleteInfoRouteStore.filterValue}
      setFilterValue={setFilterValue}
    />}
    isReady={!patientsIncompleteInfoRouteStore.http.listingPatients || patientsStore.dataForPharmacist.size}
    onBottomThreshold={listPatients}
  >
    {
      patientsStore.dataForPharmacistList.map((patient) => (
        <ListItem
          key={patient.id}
          title={`${patient.firstName} ${patient.lastName}`}
          isActive={patientsIncompleteInfoRouteStore.activePatientId === patient.id}
          iconStyle={{width: '50px', height: '50px'}}
          icon={
            <img
              alt='Patient'
              className='patient-icon-preview'
              src={PatientIcon}
            />
          }
          url={`${rootRoute}/${patient.id}`}
        >
          <Patient
            externalPharmacyId={patient.externalPharmacyId}
            DOB={patient.DOB}
            createdAt={patient.createdAt}
          />
        </ListItem>
      ))
    }
  </List>
);

export default observer(PatientsList);
